import React, { useEffect } from 'react';

// interface
import { ILinkedIconModuleProps, ILinkProps } from '../../../interfaces/interfaces';

// module, source
import Header from '../../elements/Header/Header';
import Link from '../../elements/Link/Link';
import TileWrapper from '../../elements/TileWrapper/TileWrapper';

function LinkedIconModule(props: ILinkedIconModuleProps & ILinkProps): JSX.Element {
  const { headline, ariaLabel, linkText, linkHref, locked, tileId, isEditable, hideMenu, dataAttributes, iconUrl } =
    props;

  useEffect(() => {
    // eslint-disable-next-line
    // @ts-ignore
    document.dispatchEvent(new CustomEvent('application.reinit', ['ajax-overlay', 'media-overlay']));
  }, []);

  return (
    <>
      <div className={`tile-body ${locked && 'locked'}`}>
        {headline ? <Header headline={headline} tileId={tileId} hideMenu={hideMenu} isEditable={isEditable} /> : ''}
        <TileWrapper className="tile-padding" clickable>
          <div className="icon">
            <img src={iconUrl} alt="NO ICON" />
          </div>
          <Link
            linkHref={linkHref}
            linkText={linkText}
            ariaLabel={ariaLabel}
            linkClass="tile-link link overlay-open ic-arrowRight"
            locked={locked}
            dataAttributes={dataAttributes}
            linkTextClass="link-text"
          />
        </TileWrapper>
      </div>
    </>
  );
}
export default LinkedIconModule;
